import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { Url } from '@wix/da-url';
import { Trans, useTranslation } from 'react-i18next';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { BiData } from '@wix/da-bi/pkg/events';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import HiddenIcon from '@wix/da-ds/pkg/Icons/32x32/Hidden';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import HiddenLayout from './HiddenLayout';
import hiddenStyles from './Hidden.scss';
/** an overlay to cover nsfgoogle content. it handles three cases:
 *  logged-out users, logged-in underage users, and over 18 logged-in users */ const NsfgBlockedOverlay = (_param)=>{
    var { compact, isLoggedIn, isUserOlderThan18, overrideMatureFilter, pushUserSettingsModal } = _param, props = _object_without_properties(_param, [
        "compact",
        "isLoggedIn",
        "isUserOlderThan18",
        "overrideMatureFilter",
        "pushUserSettingsModal"
    ]);
    // note: unlike mature, which tests for and flags logged-out and underage users
    // on the server-side, nsfg does it here on the client
    const { t } = useTranslation();
    // logged out
    if (!isLoggedIn) {
        return /*#__PURE__*/ React.createElement(HiddenLayout, _object_spread({
            icon: /*#__PURE__*/ React.createElement(HiddenIcon, {
                size: IconSize.HUGE
            }),
            text: t('deviationview.blocked.nsfg.text'),
            button: /*#__PURE__*/ React.createElement(GhostButton, {
                variant: "main",
                size: "medium",
                href: Url.joinLink('mature'),
                biData: BiData({
                    evid: 240,
                    referral_info: ReferralType.NSFG
                })
            }, t('deviationview.blocked.nsfg.anon.signIn'))
        }, props));
    }
    // logged in, 13-18 and over 18
    const { deviation } = props;
    return /*#__PURE__*/ React.createElement(HiddenLayout, _object_spread({
        icon: /*#__PURE__*/ React.createElement(HiddenIcon, {
            size: IconSize.HUGE
        }),
        text: t('deviationview.blocked.nsfg.text'),
        button: /*#__PURE__*/ React.createElement(GhostButton, {
            variant: "main",
            size: "medium",
            onClick: ()=>overrideMatureFilter(deviation.deviationId),
            biData: BiData({
                evid: 305,
                typeid: deviation.typeId,
                itemid: deviation.deviationId
            })
        }, t('deviationview.blocked.showDeviationAnyway')),
        secondaryButton: /*#__PURE__*/ React.createElement(TextButton, {
            className: hiddenStyles['secondary-button'],
            size: "medium",
            variant: "main",
            onClick: pushUserSettingsModal,
            biData: BiData({
                evid: 306,
                typeid: deviation.typeId,
                itemid: deviation.deviationId
            })
        }, /*#__PURE__*/ React.createElement(Trans, {
            i18nKey: 'deviationview.blocked.openContentFilterModal'
        }))
    }, props));
};
NsfgBlockedOverlay.displayName = 'NsfgBlockedOverlay';
export default NsfgBlockedOverlay;

//# sourceMappingURL=NsfgBlocked.js.map